<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="header-title">Advanced Data Table</h4> -->
            <p class="text-muted font-13 mb-0"></p>
            <!-- Table -->
            <div>
              <b-card-code>
                <validation-observer ref="simpleRules">
                  <form @submit.prevent="submitForm">
                    <b-row>
                      <b-col md="4">
                        <b-form-group>
                          <label>Franchise Name</label>
                          <v-select
                            v-model="cp"
                            label="fullname"
                            placeholder="None"
                            :options="frOptions"
                          >
                            <template #option="{ fullname, profile_image, username }">
                              <b-avatar
                                :src="getprofileImage(profile_image)"
                                v-if="fullname != 'All'"
                              />
                              <span class="font-weight-bolder">
                                {{ fullname }}
                                <span v-if="fullname != 'All'"
                                  >({{ username }})</span
                                ></span
                              >
                            </template>
                          </v-select>
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group>
                          <label>Select Date</label>
                          <flat-pickr
                            class="form-control"
                            value=""
                            :config="{
                              dateFormat: 'd/m/Y',
                              mode: 'range',
                            }"
                            placeholder="Select Date"
                            style="background-color: transparent"
                            @input="getdata($event)"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <div class="d-flex justify-content-end">
                      <b-button
                        variant="primary"
                        class="ml-2"
                        @click="searchData"
                        :disabled="loading"
                      >
                        <feather-icon icon="SearchIcon" class="mr-50" />
                        <span class="align-middle">Search</span>
                      </b-button>
                    </div>
                  </form>
                </validation-observer>
                <report-table :data="flatData" :columns="fields" />
              </b-card-code>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportTable from "../../../components/ReportTable.vue";
import axios from "@/components/axios";
import BCardCode from "@core/components/b-card-code";
import flatPickr from "vue-flatpickr-component";
import GoodTableColumnSearch from "../../../components/GoodTableColumnSearch.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Form from "@/components/form/Form.vue";
import moment from "moment";
import {
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BAvatar,
  BButton,
  VBTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";

export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    ReportTable,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    vSelect,
    flatPickr,

    ValidationProvider,
    ValidationObserver,
    BCardCode,
    Form,
    BAvatar,
    GoodTableColumnSearch,
  },
  data() {
    return {
      loading: false,
      fr: "",
      cp: "",
      startdate: "",
      enddate: "",
      result: "",
      data: "",
      flatData: [],
      baseApi: process.env.VUE_APP_APIENDPOINT,
      accessToken: localStorage.getItem("accessToken"),
      imagePath: process.env.VUE_APP_IMAGE_PATH,
      leadCategory: "",
      frOptions: [],
      fields: [
        { field: "owner_name", label: "Owner's Name" },
        { field: "owner_surname", label: "Owner's Surname" },
        { field: "father_husband_name", label: "Father/Husband Name" },
        { field: "franchise_name", label: "Franchise Name" },
        { field: "franchise_establish_date", label: "Franchise Establish Date" },
        { field: "email", label: "Email" },
        { field: "mobile", label: "Mobile" },
        { field: "gender", label: "Gender" },
        { field: "joining_date", label: "Joining Date" },
        { field: "marital_status", label: "Marital Status" },
      ],
    };
  },
  mounted() {
    this.$store.dispatch("master/getFranchise");
  },
  watch: {
    "$store.state.master.franchise"(newValue, oldValue) {
      this.frOptions = [{ fullname: "All", id: 0 }, ...newValue];
    },
  },
  methods: {
    getprofileImage(image) {
      if (image !== undefined && image !== null && image !== "") {
        let test = image.includes(this.imagePath) ? image : this.imagePath + image;
        return test;
      }
      return image;
    },
    getdata(selectedDates) {
      this.result = selectedDates.split(" to ");
      this.startdate = this.result.length > 0 ? this.result[0] : "";
      this.enddate = this.result.length == 2 ? this.result[1] : "";
    },
    formatDate(value) {
      if (!value || value === "0000-00-00") return "-";
      return moment(value).format("DD/MM/YYYY");
    },
    flattenUsers(users, rows = []) {
      if (!users || !users.length) return rows;
      users.forEach((item) => {
        rows.push({
          owner_name: item.name || "-",
          owner_surname: item.surname || "-",
          father_husband_name: item.fathername || "-",
          franchise_name: item.franchisename || item.fullname || "-",
          franchise_establish_date: this.formatDate(item.franchiseestablishdate),
          email: item.email || "-",
          mobile: item.mobile || "-",
          gender: item.gender || "-",
          joining_date: this.formatDate(item.joiningdate),
          marital_status: item.maritalstatus || "-",
        });
        if (item.children && item.children.length) {
          this.flattenUsers(item.children, rows);
        }
      });
      return rows;
    },
    async searchData() {
      const data = {
        cp_id: this.cp ? this.cp.id : "",
        startdate: this.startdate ? this.startdate : "",
        enddate: this.enddate ? this.enddate : "",
      };
      this.loading = true;
      await axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        data: JSON.stringify(data),
        url: `${this.baseApi}/franchise-report`,
      })
        .then((response) => {
          this.data = response.data.data;
          this.flatData = this.flattenUsers(this.data, []);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style></style>
